import { io } from "socket.io-client";

const socket = io("https://collaboard-zv6j.onrender.com");

export default socket;